export default __webpack_public_path__ + "static/media/photo--sm--ish-1.5478d523.jpg";